import Close from '@mui/icons-material/Close';
import { Box, Modal, ModalProps, styled } from '@mui/material';
import { GlobalStyles } from '@themes/global/GlobalStyles';

// STYLES
const StyledModal = styled(Modal)`
  max-height: calc(100vh - 32px);
  width: 100vw;
  overflow-y: scroll;
`;

const CloseButton = styled(Box)`
  position: absolute;
  right: 16px;
  top: 16px;
  cursor: pointer;
`;

// TYPES
export type CommonModalProps = ModalProps;

// COMPONENTS
export const CommonModal = ({ children, onClose, ...props }: CommonModalProps) => {
  return (
    <StyledModal {...props} sx={{ outline: 'none' }} onClose={onClose}>
      <Box
        position='relative'
        sx={{ m: 4, background: '#f0f0f0', maxWidth: 600, margin: '32px auto' }}
      >
        <GlobalStyles>
          <Box sx={{ p: 4, overflowY: 'auto' }}>{children}</Box>
          {onClose && (
            <CloseButton>
              <Close onClick={(e) => onClose(e, 'backdropClick')} />
            </CloseButton>
          )}
        </GlobalStyles>
      </Box>
    </StyledModal>
  );
};
